import { StateType } from '../../types';

const reactionSelector = (slice: string, sliver: string) => (state: StateType, id: string) =>
  // Returns undefined if no reaction yet
  state[slice][sliver].reactions[id];

export default reactionSelector;
